var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 81,
    viewBox: "0 0 298 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.756 10.1059C331.323 10.3073 351 11.8812 351 11.8812V91H-45V45.0876C-14.8042 45.0876 14.1336 44.0678 42.7415 41.2981C68.7398 38.781 92.7784 35.5715 117.189 32.069C141.879 28.5264 165.238 24.3385 190.057 20.8712C214.242 17.4927 238.478 14.4258 264.172 12.0063C282.289 10.3005 301.672 9.74227 320.756 10.1059Z",
    fill: "url(#paint0_linear_118_343)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 58,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#FC7013"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 30,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#001837"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.918,
    y: 68,
    width: 10,
    height: 10,
    rx: 2,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_343",
    x1: 153,
    y1: 10,
    x2: 153,
    y2: 147.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7013"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 298,
    height: 81,
    fill: "white",
    transform: "matrix(-1 0 0 1 298 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.cec279325441d594de67c1a20ffcfa48.svg";
export { ForwardRef as ReactComponent };